<template>
  <div class="flex flex-col items-center">
    <Nav2 />
   <div class="w-full max-w-2xl   rounded-lg overflow-hidden flex flex-col items-center p-6 md:p-0 my-2">

     <div class="relative flex flex-col items-center justify-center p-1">
       <div class="absolute w-32 h-32 border border-gray-300 rounded-full"></div>
       <div class="absolute w-40 h-40 border border-gray-300 rounded-full"></div>
       <div class="absolute w-48 h-48 border border-gray-300 rounded-full"></div>

       <div class="relative flex flex-col items-center justify-center w-48 h-48 rounded-full bg-white z-10">
         <img src="/icons/loginicon.png" alt="Login Image" class="w-20 md:w-24">

         <div class="absolute w-full h-full flex flex-col items-center justify-center text-center mt-24">
           <h2 class="text-lg font-bold">Login to your account</h2>
           <p class="text-sm text-gray-600">Enter your details to login.</p>
         </div>
       </div>
     </div>

     <div class="w-full max-w-sm">
       <form @submit.prevent="handleSubmit">
         <div class="mb-4">
          <label for="phone" class="block text-sm font-medium text-gray-700">Phone Number</label>
          
          <div class="flex items-center mt-1 border border-gray-300 rounded-lg shadow-sm focus-within:ring-[#41AE49] focus-within:border-[#41AE49]">
            <!-- Country Code Dropdown -->
            <div class="relative">
              <button @click="toggleDropdown" class="flex items-center px-3 py-2 bg-gray-100 border-r border-gray-300 rounded-l-lg w-28 justify-between">
                <div class="flex items-center">
                  <img :src="selectedCountry.flag" :alt="selectedCountry.name" class="w-6 h-6 rounded-full mr-2">
                  <span class="text-sm font-medium">{{ selectedCountry.dialCode }}</span>
                </div>
                <!-- Down Arrow Icon -->
                <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              
              <!-- Dropdown -->
              <div v-if="isDropdownOpen" class="absolute left-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-20">
                <div v-for="country in countries" :key="country.code" @click="selectCountry(country)" class="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100">
                  <img :src="country.flag" :alt="country.name" class="w-6 h-6 rounded-full mr-2">
                  <span class="text-sm">{{ country.dialCode }}</span>
                  <span class="ml-2 text-gray-600">{{ country.name }}</span>
                </div>
              </div>
            </div>

            <!-- Phone Number Input -->
            <input 
              id="phone" 
              type="tel" 
              v-model="phoneNumber" 
              required 
              placeholder="8123456789" 
              class="w-full px-4 py-2 rounded-r-lg focus:outline-none"
            />
          </div>

          <p v-if="errors.phone" class="text-red-500 text-sm">{{ errors.phone }}</p>
        </div>
         <div class="mb-4">
           <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
           <input 
             id="password" 
             type="password" 
             v-model="password" 
             required 
             autocomplete="current-password"
             class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-[#41AE49] focus:border-[#41AE49]"
           />
           <p v-if="errors.password" class="text-red-500 text-sm">{{ errors.password }}</p>
         </div>

         <div class="flex items-center justify-between mb-4">
           <label class="flex items-center">
             <input type="checkbox" v-model="remember" class="h-4 w-4 text-[#41AE49] border-gray-300 rounded">
             <span class="ml-2 text-sm text-gray-600">Remember Me</span>
           </label>
           <router-link to="/forgot-password" class="text-sm text-[#41AE49] hover:underline">
             Forgot Password?
           </router-link>
         </div>

         <button type="submit"
           class="w-full py-2 px-4 bg-[#41AE49] text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-[#41AE49]">
           Login
         </button>
       </form>
     </div>
     <div class="my-5">
       <p class="text-sm text-gray-500">Don't have an account?</p>
       <p class="underline flex justify-center text-center">
         <a href="/registration">Get started</a>
       </p>
     </div>
   </div>
 </div>
</template>

<script setup>
import api from '@/services/api'
import { ref } from "vue";
import Nav2 from "./components/Nav2Vue.vue"

const password = ref("");
const remember = ref(false);
const errors = ref({});
const isDropdownOpen = ref(false);
const phoneNumber = ref("");


const selectedCountry = ref({
  code: "NG",
  name: "Nigeria",
  dialCode: "+234",
  flag: "https://flagcdn.com/w40/ng.png"
});

const countries = ref([
  { code: "NG", name: "Nigeria", dialCode: "+234", flag: "https://flagcdn.com/w40/ng.png" },
  { code: "KE", name: "Kenya", dialCode: "+254", flag: "https://flagcdn.com/w40/ke.png" },
]);

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const selectCountry = (country) => {
  selectedCountry.value = country;
  isDropdownOpen.value = false;
};

const handleSubmit = async () => {
  errors.value = {};

  const fullPhone = selectedCountry.value.dialCode + phoneNumber.value;

  if (!phoneNumber.value || phoneNumber.value.length < 6) {
    errors.value.phone = "Please enter a valid phone number.";
    return;
  }
  if (password.value.length < 6) {
    errors.value.password = "Password must be at least 6 characters.";
    return;
  }

  try {
    const response = await api.post('/api/login', {
      phone: fullPhone,
      password: password.value,
      remember: remember.value
    });

    

    // Redirect or store token/session as needed
    // e.g. localStorage.setItem('token', response.data.token);
    // router.push('/dashboard');
  } catch (error) {
    if (error.response && error.response.status === 422) {
      errors.value = error.response.data.errors || {};
    } else {
      console.error("Unexpected login error:", error);
    }
  }
};

</script>
